module.exports = __webpack_public_path__ + "officialStatic/img/detail-two1.247a8d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-two1.png
// module id = tRsx
// module chunks = 0